import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AlertService } from "./alert.service";
import { Location } from "@angular/common";
import { AppNotificationDto } from "../api/api";
import { AppNotificationType } from "../pages/dashboard/notification-page/components/notification-management/notification-management.component";

@Injectable({
  providedIn: "root",
})
export class NavigationService {
  constructor(
    private router: Router,
    private location: Location,
    private alertService: AlertService,
  ) {}

  navigateByUrl(url: string) {
    this.alertService.startLoadingMessage("Navigating...");
    this.router
      .navigateByUrl(url)
      .then((p) => {
        this.alertService.stopLoadingMessage();
      })
      .catch((e) => {
        this.alertService.stopLoadingMessage();
        this.alertService.showErrorMessage("Error in Navigation");
        console.log(e);
      });
  }

  navigateByNotification(notificationDto: AppNotificationDto) {
    switch (notificationDto.type) {
      case AppNotificationType.AtmError:
        console.log("Handling ATM Error");
        break;

      case AppNotificationType.TicketCreate:
        this.navigateByUrl("/dashboard/tickets/" + notificationDto.data);
        break;

      case AppNotificationType.TicketAssign:
        this.navigateByUrl("/dashboard/tickets/" + notificationDto.data);
        break;
      case AppNotificationType.TicketCommentCreate:
        this.navigateByUrl("/dashboard/tickets/" + notificationDto.data);
        break;
      case AppNotificationType.TicketResolved:
        this.navigateByUrl("/dashboard/tickets/" + notificationDto.data);
        break;
      case AppNotificationType.AtmNotesLow:
      case AppNotificationType.AtmCassetteStopped:
        console.log("Handling ATM cash notification");
        break;
      case AppNotificationType.WithdrawalRequestApproved:
      case AppNotificationType.WithdrawalRequestRejected:
      case AppNotificationType.WithdrawalRequestCancelled:
        console.log("Handling withdrawal notification");
        break;

      default:
        console.log("Unknown notification type");
    }
  }

  back() {
    this.location.back();
  }
}
